import React from 'react';
/**
 * Shop All Products SEO-friendly category description block. Marked with
 * `category-description` / `wf-category-description` so the WebsiteForge
 * importer can populate this region dynamically per category.
 */
export function Description() {
  return <div className="category-description wf-category-description mb-12 max-w-4xl" data-id="element-797">
      <div className="prose prose-gray text-gray-700 text-base sm:text-lg leading-relaxed" data-id="element-798">
        Browse our complete catalog of Daedo and Wacoku Taekwondo equipment,
        including electronic scoring systems, protective gear, uniforms, and
        training accessories. Every product on TKDScore.com is sourced through
        official channels and backed by our U.S.-based support team.
      </div>
    </div>;
}